(() => {
  if (window.ejVideoControlsLoaded) return;
  window.ejVideoControlsLoaded = true;

  function initialize(root = document) {
    root.querySelectorAll(".ej-video-toggle").forEach((button) => {
      if (button.dataset.initialized) return;

      const wrapper = button.closest(
        "[data-ej-video], .product__video-wrapper"
      );
      const video = wrapper && wrapper.querySelector("video");
      if (!video) return;

      button.dataset.initialized = "true";
      let manuallyPaused = false;

      function update() {
        button.setAttribute(
          "aria-label",
          video.paused || video.ended
            ? "Play video"
            : "Pause video"
        );
      }

      button.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (video.paused || video.ended) {
          manuallyPaused = false;
          video.play().catch(update);
        } else {
          manuallyPaused = true;
          video.pause();
        }

        update();
      });

      video.addEventListener("play", () => {
        if (manuallyPaused) video.pause();
        update();
      });

      video.addEventListener("pause", update);
      video.addEventListener("ended", update);

      update();
      button.hidden = false;
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      () => initialize(),
      { once: true }
    );
  } else {
    initialize();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initialize(event.target);
  });
})();
